<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="step"
    width="58"
    height="29"
    viewBox="1753 1201 58 29"
  >
    <g id="Five" fill="none">
      <path
        d="M1753 1201L1800 1201 1809.5 1213.9C1810.2 1214.8 1810.2 1216.2 1809.5 1217.1L1800 1230 1753 1230 1753 1201Z"
        id="Rectangle-55"
        fill="#4990E2"
      />
      <path
        d="M1766.5 1219.8C1767.5 1221.5 1769.1 1222.2 1770.5 1222.2 1773.8 1222.2 1775.3 1219.8 1775.3 1217.4 1775.3 1214.4 1772.6 1212.4 1769.5 1213.5L1769.5 1212.1 1774.5 1212.1 1774.5 1209.3 1766.9 1209.3 1766.9 1216.7 1768.4 1216.7C1769 1215.9 1769.7 1215.6 1770.5 1215.6 1771.5 1215.6 1772.2 1216.2 1772.2 1217.5 1772.1 1219 1770 1219.5 1768.8 1218L1766.5 1219.8Z"
        id="5"
        fill="#FFF"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'StepFiveIcon'
}
</script>
